module.exports = __webpack_public_path__ + "img/scenario_11.4783146a.jpg";